import React from 'react';
import { Activity, CheckCircle2, DollarSign, ShieldCheck, Wrench } from 'lucide-react';
import { useAudit } from '../context/AuditContext';
import { getDiagnosticMetrics } from '../utils/diagnosticMetrics';
import { Progress } from './ui/progress';

export const DiagnosticProgress = () => {
  const { auditData } = useAudit();
  const metrics = getDiagnosticMetrics(auditData);

  return (
    <div className="sticky top-0 z-30 border-b border-primary/10 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/85">
      <div className="container mx-auto px-6 py-3">
        <div className="max-w-6xl mx-auto space-y-2">
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <div className="flex items-center gap-2 text-primary font-bold">
              <Activity className="h-4 w-4" />
              <span>Diagnostic in progress</span>
              <span className="text-sm font-medium text-muted-foreground">· {metrics.readinessLabel}</span>
            </div>
            <div className="text-sm font-semibold text-primary">{metrics.completionPercent}% built</div>
          </div>
          <Progress value={metrics.completionPercent} className="h-2" />
          <div className="grid grid-cols-2 gap-2 text-xs text-muted-foreground md:grid-cols-4">
            <div className="flex items-center gap-1"><CheckCircle2 className="h-3 w-3 text-primary" /> {metrics.answeredRatings}/{metrics.totalRatings} signals</div>
            <div className="flex items-center gap-1"><Wrench className="h-3 w-3 text-primary" /> {metrics.toolsMapped} tools mapped</div>
            <div className="flex items-center gap-1"><DollarSign className="h-3 w-3 text-primary" /> ${metrics.manualWorkCost.toLocaleString()} manual cost</div>
            <div className="flex items-center gap-1"><ShieldCheck className="h-3 w-3 text-primary" /> {metrics.riskFlags} risk flags</div>
          </div>
        </div>
      </div>
    </div>
  );
};
